import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

export const usePresignErrorToast = () => {
  const [searchParams, setSearchParams] = useSearchParams(); // Sacamos los query params
  // Extraemos el posible error que venga del PreSign Lambda
  const presignLambdaError = searchParams.get("error_description");

  // Transformamos el error y lo mostramos
  useEffect(() => {
    if (presignLambdaError) {
      const decoded = decodeURIComponent(presignLambdaError);
      const message = decoded.replace(
        /^PreSignUp failed with error (?:Error)?:\s*/i,
        ""
      );
      toast.error(message);

      // Limpia la URL
      searchParams.delete("error_description");
      setSearchParams(searchParams, { replace: true });
    }
  }, [presignLambdaError]);
};
